<template>
  <div class="selector-item">
    <m-item-wrapper>
      <div
        :class="classes"
        :style="contentStyle"
        @click="select(item)"
      >
        <m-tag
          :key="item.uid"
          :color="item.uid === UNASSIGNED ? COLOR_NONE : item.color"
          :title="item.title"
          :title-style="{ 'font-weight': 'normal' }"
          small
        />
        <div class="_checkmark">
          <m-icon
            v-if="isSelected"
            type="check"
          />
        </div>
      </div>
    </m-item-wrapper>
    <div class="_children">
      <selector-item
        v-for="c in item.children"
        :key="c.uid"
        :item="c"
        :level="level + 1"
        :selected="selected"
        :selectable="selectable"
        @select="$emit('select', $event)"
      />
    </div>
  </div>
</template>

<script>
import { COLOR_NONE } from 'shared/constants';
import { UNASSIGNED } from '@/lib/constants';

export default {
  name: 'SelectorItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    selected: {
      type: Array,
      required: true,
    },
    selectable: {
      type: Boolean,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
  },
  emits: ['select'],
  data() {
    return {
      visible: false,
      UNASSIGNED,
      COLOR_NONE,
    };
  },
  computed: {
    classes() {
      return [
        '_content',
        this.selectable ? '-selectable' : '',
      ];
    },
    isSelected() {
      return this.selected.map((c) => c.uid).filter((s) => s === this.item.uid).length > 0;
    },
    contentStyle() {
      return { paddingLeft: `${this.level * 1.5 + 3}rem` };
    },
  },
  methods: {
    select(item) {
      if (!this.selectable) {
        return;
      }
      this.$emit('select', item);
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">

  .selector-item {
    ._content {
      position: relative;
      display: flex;
      gap: .8rem;
      align-items: center;
      height: 3rem;
      padding: 0 1rem;
      cursor: pointer;
      border-radius: $btn-border-radius;

      ._checkmark {
        display: flex;
        justify-content: flex-end;
        width: 4rem;
        margin-left: auto;
      }

      &.-selectable:hover {
        background-color: $hover-color;
      }
    }
  }
</style>
